
import React from 'react';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const Footer = () => {
  const year = new Date().getFullYear();
  
  // Social media links with updated LinkedIn URL
  const socialLinks = [
    { 
      name: 'Facebook', 
      icon: Facebook, 
      url: '#', 
      hint: 'Visit my Facebook profile'
    },
    { 
      name: 'Instagram', 
      icon: Instagram, 
      url: '#', 
      hint: 'Follow me on Instagram'
    },
    { 
      name: 'LinkedIn', 
      icon: Linkedin, 
      url: 'https://www.linkedin.com/in/paytonmhunter', 
      hint: 'Connect with me on LinkedIn'
    },
    { 
      name: 'Email', 
      icon: Mail, 
      url: 'mailto:PaytonMHunter7@gmail.com', 
      hint: 'Send me an email'
    }
  ];
  
  return (
    <footer className="bg-sage-800 dark:bg-sage-950 text-white py-8 px-6">
      <div className="container max-w-5xl mx-auto">
        <div className="flex flex-col items-center">
          <div className="text-center mb-6">
            <h3 className="font-serif text-xl mb-1">Payton Hunter</h3>
            <p className="text-sage-200 dark:text-sage-300 text-sm">Human-Centered Professional with a Psychology Lens</p>
          </div>
          
          <div className="flex flex-col items-center space-y-4">
            {/* Social Media Icons with centered styling */}
            <div className="flex justify-center space-x-6 mb-4">
              {socialLinks.map((social, index) => (
                <TooltipProvider key={index}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <a 
                        href={social.url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="text-sage-200 dark:text-sage-300 hover:text-white transition-colors text-2xl"
                        aria-label={`Visit ${social.name}`}
                      >
                        <social.icon size={24} className="hover:scale-110 transition-transform" />
                      </a>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white dark:bg-sage-800 text-sage-800 dark:text-white border-sage-200 dark:border-sage-700">
                      <p>{social.hint}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ))}
            </div>
            
            <div className="text-center">
              <p className="text-sage-200 dark:text-sage-300 text-sm">
                &copy; {year} All Rights Reserved
              </p>
              <p className="text-sage-300 dark:text-sage-400 text-xs mt-1">
                Designed with passion and purpose
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
